import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ThreeDArcadeGames,
  ThreeDActionGames,
  ThreeDRacingGames,
  ThreeDCasinoGames,
  ThreeDSportsGames,
  ThreeDAdventureGames,
} from "../../../app-constants-updated";

function Diverseportfolio() {
  return (
    <section className="diverse_portfolio p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Our Diverse <span>3D Game</span> Development Portfolio
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="portfolio-main">
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">{ThreeDArcadeGames}</div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Arcade games</h5>
                  </div>
                </div>
              </div>
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">{ThreeDActionGames}</div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Action & RPG games</h5>
                  </div>
                </div>
              </div>
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">{ThreeDRacingGames}</div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Racing games</h5>
                  </div>
                </div>
              </div>
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">{ThreeDCasinoGames}</div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Casino & Card games</h5>
                  </div>
                </div>
              </div>
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">{ThreeDSportsGames}</div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Sport games</h5>
                  </div>
                </div>
              </div>
              <div className="portfolio-item">
                <div className="portfolio-box">
                  <div className="portfolio-icon">
                    <div className="portfolio-circle">
                      {ThreeDAdventureGames}
                    </div>
                  </div>
                  <div className="portfolio-head">
                    <h5>Adventure games</h5>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Diverseportfolio;
